
import { Component, ViewChild } from '@angular/core';
import { FormControl, FormBuilder } from '@angular/forms';
import { NavController } from 'ionic-angular/navigation/nav-controller';
import { FriendListPage } from './friend-list';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { NavParams, IonicPage, Content } from 'ionic-angular';
import { ChatService } from '../../services/chat.service';
import { StorageService } from '../../providers/storage.service';
import * as moment from "moment";
import { ImService } from "./im.service";
import { AlertService } from '../../providers/alert.service';
import { App } from 'ionic-angular/components/app/app';
import { SigninPage } from '../signin/signin';
import { HomePage } from '../home/home';
import { EmojiService } from "../../services/emoji.service";
@IonicPage()
@Component({
    selector: 'page-chat-details',
    templateUrl: 'chat-details.html',
    providers: [
        ChatService,
        ImService
    ]
})
export class ChatDetailsPage {
    messages = [];          //聊天记录内容
    @ViewChild(Content) content: Content;
    public messageForm: any;
    chatBox: any;           // 输入框输入的内容
    chatUser: string;       //聊天对象
    upUser: string;         //获取到的上级的真实名字
    sendMessage;            //发出去的消息
    receiveMessage;         //接收到的消息
    parentUserName: any;    //上级用户名
    perUser;                //当前登录的用户
    getHistoryList;         //轮询获取最新消息
    IsBanned: boolean = false;
    IsBlacklist: boolean = false;
    noSpeak: boolean = false;
    emojis = [];
    isShowEmojiList: boolean = false;
    intervalTime: number = 3; // 3秒发送信息间隔
    clInterval: any;
    allUser;    //所有成员
    nextUser;   //直属下级
    userArr = [];  // 消息框下面的抄送
    msgType: number;  //  发送的消息类型type=1 是所有人  2 是所有下级  3自由选中（要传用户名) -1是单聊(可传可不传)
    constructor(
        private nav: NavController,
        private viewCtrl: ViewController,
        private params: NavParams,
        private formBuilder: FormBuilder,
        private chat: ChatService,
        private storage: StorageService,
        private imservice: ImService,
        private alert: AlertService,
        private appCtrl: App,
        private emoji: EmojiService
    ) {
        this.messageForm = formBuilder.group({
            message: new FormControl('')
        });
        this.chatBox = '';
        // 1所有人 2 所有下级
        this.userArr = [
            { name: '所有成员', checked: false, type: 1 },
            { name: '直属下级', checked: false, type: 2 }
        ]
    }
    ionViewDidLoad() {
        this.chatUser = this.params.get('FromUserName');
        this.parentUserName = this.imservice.getParentUserName();
        this.perUser = this.imservice.getUserName();
        this.scrollToBottom();
    }
    // 页面销毁清空计时器
    ionViewDidLeave() {
        clearInterval(ImService.getHistoryList);
        clearInterval(ImService.getMessageCount);
    }
    ionViewDidEnter() {
        this.emojis = this.emoji.getEmoji();
        this.getChatMessage();
    }
    hideEmojiList() {
        if (this.isShowEmojiList) {
            this.isShowEmojiList = !this.isShowEmojiList;
        }
    }
    // 点击空白隐藏表情框
    onMessageHold() {
        this.hideEmojiList()
    }
    // 将选中的表情写入输入框
    pushEmojiToTextarea(emoji: any) {
        this.chatBox = this.chatBox + emoji;
    }
    showEmojiList() {
        this.scrollToBottom();
        this.isShowEmojiList = !this.isShowEmojiList;
    }

    // ion-checkbox 多选改单选，ion-radio样式不符合要求，不选这个
    checkUser(user) {
        if (user.checked) {
            this.msgType = user.type;
        } else {
            this.msgType = -1;
        }
        let checkitem = user.name;
        for (var i = 0; i < this.userArr.length; i++) {
            if (this.userArr[i].name == checkitem) {
                this.userArr[i].checked = true;
            } else {
                this.userArr[i].checked = false;
            }
        }
    }
    // 发送消息
    send(message) {
        if (message.length > 50) {
            this.alert.showAlert('信息发送限制为每句50字以内，谢谢！');
            return;
        }
        // 设置发送信息间隔为3秒钟
        if (this.intervalTime > 0 && this.intervalTime < 3) {
            this.alert.showAlert("信息发送限制为3秒1次，谢谢！");
            return;
        } else {
            this.clInterval = setInterval(() => {
                this.intervalTime--;
                if (this.intervalTime == 0) {
                    clearInterval(this.clInterval);
                    this.intervalTime = 3;
                }
            }, 1000);
        }
        this.hideEmojiList();
        this.getImToker();
        var str = message.replace(/(^\s*)|(\s*$)/g, '');
        if (str == '' || str == undefined || str == null) {
            this.alert.showAlert('不能发送空白消息!');
            return;
        }
        if (message && message !== '') {
            let sendMessage = {
                ToUserName: this.chatUser,
                Message: message,
                Type: this.msgType
            };
            // 发送消息
            this.chat.sendMessage(sendMessage).then(res => {

            }, err => {

            });
            this.chatBox = '';
            // 发送完消息立即调取接口获取最新消息
            const time1 = setTimeout(() => {
                this.getNewHistoryMsg();
                clearTimeout(time1);
            }, 700)
            this.scrollToBottom();
        }
    }
    // 获取聊天记录，只用来第一次获取
    getChatMessage() {
        this.messages = [];
        let params = {
            toUserName: this.chatUser,
            pageSize: 20,
            pageIndex: 1,
        }
        this.imservice.getFirstHistoryMessage(params, this.perUser, this.messages);
        this.scrollToBottom();
        this.getNewHistoryMsg();
        ImService.getHistoryList = setInterval(() => {
            this.getNewHistoryMsg();
        }, 10000)
    }
    getNewHistoryMsg() {
        let maxId = this.storage.read('maxId');
        if (maxId) {
            let param = { toUserName: this.chatUser, maxId: maxId, pageSize: 20, isNewMessage: true }
            this.chat.getNewHistoryMsg(param).then(s => {

                if (s && s.length > 0) {
                    let maxID = s[s.length - 1].Id;
                    this.storage.write('maxId', maxID);
                    s.forEach(e => {
                        this.imservice.setMessageIsRead(e, this.perUser);
                        const newMessage = {
                            toUserName: e.ToUserName,
                            sendTime: ImService.moment(e.CreateTime),
                            text: e.Message
                        };
                        // 删除id=0的插入的消息
                        this.messages.forEach((s, i) => {
                            if (s.id == 0) {
                                this.messages.splice(i, 1)
                            }
                        });
                        this.messages.push(newMessage);
                        this.scrollToBottom();
                    });
                }
            }
            ).catch((err) => {
                if (err.status === 401 || err.status === 403) {
                    this.alert.showAlert("验证已失效，您需要退出重新登录!");
                    clearInterval(ImService.getMessageCount);
                    clearInterval(ImService.getHistoryList);
                    clearInterval(ImService.getMessageList);
                    localStorage.clear();
                    this.appCtrl.getRootNav().setRoot(SigninPage);
                }
            })
        }
    }
    // 下拉加载
    doRefresh(refresher) {
        let minId = this.storage.read('minId');
        let param = {
            toUserName: this.chatUser,
            maxId: minId,
            pageSize: 20,
            isNewMessage: false
        }
        this.chat.getNewHistoryMsg(param).then(s => {
            // 如何长度为零，标识已经没有最新消息
            if (s && s.length == 0) {
                this.alert.showAlert('已无更多消息...');
                refresher.complete();
                return;
            }
            let minID = s[0].Id;
            this.storage.write('minId', minID);
            s.forEach(e => {
                this.imservice.setMessageIsRead(e, this.perUser);
                let historyMessage = {
                    toUserName: e.ToUserName,
                    sendTime: ImService.moment(e.CreateTime),
                    text: e.Message,
                };
                setTimeout(() => {
                    refresher.complete();
                    // 要在关闭loading的时候加载消息，下拉立即加载，体验不好
                    this.messages.unshift(historyMessage);
                }, 2000);
            });
        }).catch((err) => {
            if (err.status === 401 || err.status === 403) {
                this.alert.showAlert("验证已失效，您需要退出重新登录!");
                clearInterval(ImService.getMessageCount);
                clearInterval(ImService.getHistoryList);
                clearInterval(ImService.getMessageList);
                localStorage.clear();
                this.appCtrl.getRootNav().setRoot(SigninPage);
            }
        })
    }
    // 获取黑名单配置
    getImToker() {
        this.chat.GetChatUserBannedAsync().then(s => {
            this.noSpeak = s.Parameter2.IsBanned || s.Parameter2.IsBlacklist;
            if (s.Parameter2.IsBlacklist) {
                this.alert.showAlert('您已被禁言，请联系客服');
                this.nav.push(HomePage);
            }
        })
    }
    scrollToBottom() {
        setTimeout(() => {
            this.content.scrollToBottom();
        }, 100);
    }
    enterFriendList() {
        this.nav.push(FriendListPage);
    }
    dismiss() {
        this.viewCtrl.dismiss();
    }
}



// WEBPACK FOOTER //
// ./src/pages/im/chat-details.ts